var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    { staticClass: "border-b" },
    [
      _vm._l(_vm.cols, function (colNum, index) {
        return _c(
          "td",
          { key: index, staticClass: "px-3 py-3 whitespace-wrap" },
          [_vm._t(`col${colNum}`)],
          2
        )
      }),
      _c(
        "td",
        {
          staticClass:
            "px-3 py-3 whitespace-wrap text-right leading-5 font-medium space-x-2",
        },
        [_c("div", { staticClass: "flex items-center" }, [_vm._t("action")], 2)]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }